import { AccountHierarchyResponseTypeEnum } from '@monetize/types/app';
import {
  useGetAccountById,
  useGetAccountHierarchyById,
} from '../../../api/accountsService';
import {
  MCenterModal,
  MTab,
  MTabList,
  MTabPanel,
  MTabPanels,
  MTabs,
} from '../../../components/Monetize';
import { AccountHierarchyForm } from './AccountHierarchyForm';
import { AccountHierarchyTree } from './AccountHierarchyTree';

interface AccountHierarchyModalProps {
  accountId: string;
  isReadOnly?: boolean;
  isOpen?: boolean;
  onClose: () => void;
}

export const AccountHierarchyModal = ({
  accountId,
  isOpen = true,
  isReadOnly = false,
  onClose,
}: AccountHierarchyModalProps) => {
  const { data: account } = useGetAccountById(accountId, {
    enabled: !!accountId,
  });
  const {
    data: accountHierarchy,
    isLoading,
    refetch,
  } = useGetAccountHierarchyById(
    account?.rootAccountId || account?.id || '',
    AccountHierarchyResponseTypeEnum.NESTED,
    {
      enabled: !!account?.rootAccountId || !!account?.id,
    },
  );

  return (
    <MCenterModal
      size="xl"
      isOpen={isOpen}
      onClose={onClose}
      modalTitle="Account Hierarchy"
      modalContentProps={{ 'data-testid': 'account-hierarchy-modal' } as any}
      closeOnOverlayClick={false}
      isLoading={isLoading}
    >
      {accountHierarchy && account && (
        <MTabs>
          <MTabList>
            <MTab>Account Hierarchy</MTab>
            <MTab>Parent Account</MTab>
          </MTabList>
          <MTabPanels>
            <MTabPanel px={0}>
              <AccountHierarchyTree
                hierarchy={accountHierarchy}
                currentAccountId={account.id}
              />
            </MTabPanel>
            <MTabPanel px={0}>
              <AccountHierarchyForm
                account={account}
                isReadOnly={isReadOnly}
                onSave={() => onClose()}
              />
            </MTabPanel>
          </MTabPanels>
        </MTabs>
      )}
    </MCenterModal>
  );
};
